import { render, staticRenderFns } from "./IntegrationToken.vue?vue&type=template&id=507ca822"
import script from "./IntegrationToken.vue?vue&type=script&lang=js"
export * from "./IntegrationToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports